<template>
    <div style="width: 100%;scroll-behavior: smooth;">
        <div style="margin-bottom: 15px;width: 1120px;margin: 0 auto;">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/', query: {tab: 0} }">首页</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/NQI' }">NQI站点</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/NQIDetail' }">站点信息</el-breadcrumb-item>
                <el-breadcrumb-item>临淄区厨具行业质量“一站式”服务站</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="top-bottom" style="margin-top: 10px;">
            <img src="../../assets/img/chuju/cj_main.png" alt="">
        </div>
        <!-- <div style="margin: 10px 23%;min-width: 680px;"> -->
        <div style="margin: 0 auto;width: 1120px;">
            <div class="one">
              <div style="display: flex;flex-direction: row;box-sizing: border-box;">
                <div style="display: flex;flex-direction: column;width: 65%;padding: 5px 0;">
                    <div style="background-color: #DCDCDC;display: flex;justify-content: space-between;height: 30px;align-items: center;padding: 0 10px;">
                        <div><span style="font-size: 12px;color: #898989;" @click="more('新闻资讯')">更多+</span><span style="font-weight: 600;font-size: 15px;margin-left: 10px;">新闻资讯</span></div>
                        <div>
                                                                                                                          <!-- @click="tab1('行业动态')" -->
                            <span :class="indexSelete1 == '行业动态'?'textSelected':'noTextSelected'" style="padding: 10px 10px;font-size: 13px;">行业动态</span>
                            <!-- <span :class="indexSelete1 == '厨具新闻'?'textSelected':'noTextSelected'" style="padding: 10px 10px;font-size: 13px;" @click="tab1('厨具新闻')">厨具新闻</span> -->
                            <!-- <span :class="indexSelete1 == '能力提升'?'textSelected':'noTextSelected'" style="padding: 10px 10px;font-size: 13px;" @click="tab1('能力提升')">能力提升</span> -->
                        </div>
                    </div>
                    <div style="display: flex;flex-direction: row;flex: 1;padding: 10px;background-color: white;justify-content: center;align-items: center;">
                        <div style="padding: 5px;display: flex;flex-direction: column;width: 45%;">
                          <el-carousel height="290px"  arrow="always" indicator-position="none">
                            <el-carousel-item v-for="(item,index) in pictureList"  :key="index">
                              <div @click="toDetail(item,'新闻资讯',item.typename)">
                                <img :src="getUrl() + item.coverPhoto" style="width: 100%;height: 250px;margin-bottom: 10px;object-fit: contain;" alt="">
                                <span class="two-line-ellipsis" style="margin-top: 10px;color: #0053B9;font-size: 12px;text-align: center;width: 96%;margin: 0 2%;">{{ item.title?item.title:getContent(item.content) }}</span>
                              </div>
                            </el-carousel-item>
                          </el-carousel>
                        </div>
                        <div style="flex: 1;padding: 0px 10px;">
                            <div style="display: flex;flex-direction: column;justify-content: flex-end;padding: 15px 0;border-bottom: 1px solid #E5E5E5;margin-bottom: 7px;"  @click="toDetail(newList[0],'新闻资讯',indexSelete1)">
                                <span class="one-line-ellipsis" style="color: #0053B9;font-size: 17px;font-weight: 600;">{{ newList.length>0?(newList[0]?.title || ''):'' }}</span>
                                <span class="two-line-ellipsis" style="margin-top: 10px;color: #F68B25;font-size: 15px;font-weight: 500;">{{ newList.length>0?getContent(newList[0].content):'' }}</span>
                            </div>
                            <div style="display: flex;flex-direction: row;padding: 8px 5px;align-items: stretch;" v-for="(item,index) in newList.slice(1, 6)"  :key="index" @click="toDetail(item,'新闻资讯',indexSelete1)">
                              <div style="display: flex;align-items: center;"><span style="display: flex;width: 12px;height: 12px;border-radius: 50%;border: 2px solid #F68B25;"></span></div>
                              <div class="one-line-ellipsis" style="color: #0053B9;font-size: 16px;width: 96%;margin: 0 2%;">
                                {{ item.title || '' }}
                              </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div style="padding: 5px 10px;flex: 1;display: flex;flex-direction: column;">
                    <div style="background-color: #DCDCDC;display: flex;justify-content: space-between;height: 30px;align-items: center;padding: 0 10px;">
                        <div><span style="font-weight: 600;font-size: 15px;">需求征集</span></div>
                        <div><span style="font-size: 12px;color: #898989;" @click="more('需求征集')">更多+</span></div>
                    </div>
                    <div style="background-color: white;">
                      <div style="padding: 10px;flex: 1;padding: 10px 10px 5px;">
                        <div v-if="needList.length > 0">
                          <div class="one-line-ellipsis" style="height: 45px;line-height: 45px;font-size: 15px;" v-for="(item,index) in needList.slice(0, 4)"  :key="index" @click="toDetail(item,'需求征集','需求征集')">
                            {{ item.title || '' }}
                          </div>
                        </div>
                        <div v-else style="flex: 1;display: flex;align-items: center;justify-content: center;height: 310px;">
                            <el-empty description="暂无数据"></el-empty>
                        </div>
                      </div>
                      <div style="flex: 1;width: 100%;padding: 5px 10px 10px;">
                        <img src="../../assets/img/chuju/xqxqLogo.png" style="width: 100%;height: 170px;" alt="">
                      </div>
                    </div>
                </div>
              </div>
            </div>
            <div class="two">
                <div style="display: flex;flex-direction: row;box-sizing: border-box;">
                    <div style="display: flex;flex-direction: column;width: 50%;padding: 5px 0;">
                        <div style="background-color: #DCDCDC;display: flex;justify-content: space-between;height: 30px;align-items: center;padding: 0 10px;margin-bottom: 5px;">
                            <div><span style="font-size: 12px;color: #898989;" @click="more('企业发展')">更多+</span><span style="font-weight: 600;font-size: 15px;margin-left: 10px;">企业发展</span></div>
                            <div>
                                <span :class="indexSelete2 == '认证赋能'?'textSelected':'noTextSelected'" style="padding: 10px 10px;font-size: 13px;" @click="tab2('认证赋能')">认证赋能</span>
                                <span :class="indexSelete2 == '标准建设'?'textSelected':'noTextSelected'" style="padding: 10px 10px;font-size: 13px;" @click="tab2('标准建设')">标准建设</span>
                                <span :class="indexSelete2 == '质量提升'?'textSelected':'noTextSelected'" style="padding: 10px 10px;font-size: 13px;" @click="tab2('质量提升')">质量提升</span>
                            </div>
                        </div>
                        <div style="padding: 10px 0;background-color: white;">
                          <div v-if="developList.length > 0" style="height: 310px;">
                            <div style="display: flex;flex-direction: row;flex: 1;padding: 7px 10px;" v-for="(item,index) in developList"  :key="index" @click="toDetail(item,'企业发展',indexSelete2)">
                              <div style="padding: 0px 10px;display: flex;flex-direction: row;align-items: stretch;">
                                  <div style="display: flex;align-items: center;"><span style="display: flex;width: 12px;height: 12px;background: #D7D7D7;border-radius: 50%;"></span></div>
                                  <div class="one-line-ellipsis" style="font-size: 15px;flex: 1;margin-left: 4px;height: 17px;">
                                    {{ item.title || '' }}
                                  </div>
                              </div>
                            </div>
                          </div>
                          <div v-else style="flex: 1;display: flex;align-items: center;justify-content: center;height: 310px;">
                              <el-empty description="暂无数据"></el-empty>
                          </div>
                        </div>
                    </div>
                    <div style="padding: 5px 10px;flex: 1;display: flex;flex-direction: column;">
                        <div style="background-color: #DCDCDC;display: flex;justify-content: space-between;height: 30px;align-items: center;padding: 0 10px;margin-bottom: 5px;">
                            <div><span style="font-size: 12px;color: #898989;" @click="more('技术服务')">更多+</span><span style="font-weight: 600;font-size: 15px;margin-left: 10px;">技术服务</span></div>
                            <div>
                                <span :class="indexSelete3 == '产品技术性能指导'?'textSelected':'noTextSelected'" style="padding: 10px 10px;font-size: 13px;" @click="tab3('产品技术性能指导')">产品技术性能指导</span>
                                <span :class="indexSelete3 == '企业产品质量抽检公布'?'textSelected':'noTextSelected'" style="padding: 10px 10px;font-size: 13px;" @click="tab3('企业产品质量抽检公布')">企业产品质量抽检公布</span>
                            </div>
                        </div>
                        <div style="padding: 10px 0;background-color: white;">
                          <div v-if="technicalList.length > 0" style="height: 310px;">
                            <div style="display: flex;flex-direction: row;flex: 1;padding: 7px 10px;" v-for="(item,index) in technicalList" :key="index"  @click="toDetail(item,'技术服务',indexSelete3)">
                              <div style="padding: 0px 5px;display: flex;flex-direction: row;align-items: stretch;">
                                  <div style="display: flex;align-items: center;"><span style="display: flex;width: 12px;height: 12px;background: #D7D7D7;border-radius: 50%;"></span></div>
                                  <div class="one-line-ellipsis" style="font-size: 15px;flex: 1;margin-left: 4px;height: 17px;">
                                    {{ item.title || '' }}
                                  </div>
                              </div>
                            </div>
                          </div>
                          <div v-else style="flex: 1;display: flex;align-items: center;justify-content: center;height: 310px;">
                              <el-empty description="暂无数据"></el-empty>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="three">
                <div style="display: flex;flex-direction: row;box-sizing: border-box;">
                    <div style="display: flex;flex-direction: column;width: 65%;padding: 5px 0;">
                        <div style="background-color: #DCDCDC;display: flex;justify-content: space-between;height: 30px;align-items: center;padding: 0 10px;">
                            <span style="font-weight: 600;font-size: 15px;">企业展示</span>
                            <span style="font-size: 12px;color: #898989;" @click="more('企业展示')">更多+</span>
                        </div>
                        <div style="display: flex;flex: 1;padding: 10px;background-color: white;">
                            <div v-if="showList.length > 0" style="flex: 1;padding: 0px 10px;">
                                <div v-for="(item,index) in showList.slice(0, 6)"  :key="index" @click="toDetail(item,'企业展示','企业展示')">
                                  <span class="one-line-ellipsis" style="font-size: 15px;width: 96%;margin: 0 2%;line-height: 45px;height: 45px;">{{ item.title || '' }}</span>
                                </div>
                            </div>
                            <div v-else style="flex: 1;display: flex;align-items: center;justify-content: center;height: 235px;">
                                <el-empty description="暂无数据"></el-empty>
                            </div>
                        </div>
                    </div>
                    <div style="padding: 5px 10px;flex: 1;display: flex;flex-direction: column;">
                        <div style="background-color: #DCDCDC;display: flex;justify-content: space-between;height: 30px;align-items: center;padding: 0 10px;">
                            <div><span style="font-weight: 600;font-size: 15px;">消费维权</span></div>
                            <div><span style="font-size: 12px;color: #898989;" @click="more('消费维权')">更多+</span></div>
                        </div>
                        <div style="padding: 10px;flex: 1;background-color: white;padding: 10px;">
                          <div v-if="consumerRightsProtectionList.length > 0">
                            <div class="one-line-ellipsis" style="height: 45px;line-height: 45px;font-size: 15px;line-height: 45px;height: 45px;" v-for="(item,index) in consumerRightsProtectionList.slice(0, 6)" :key="index"  @click="toDetail(item,'消费维权','消费维权')">
                              {{ item.title || '' }}
                            </div>
                          </div>
                          <div v-else style="flex: 1;display: flex;align-items: center;justify-content: center;height: 235px;">
                              <el-empty description="暂无数据"></el-empty>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  import { Server,httpurl } from "@/server";
  //引入axios插件
  import axios from "axios";
  export default {
    data () {
      return {
        tableData: [{
            date: '2016-05-02',
            name: '王小虎',
            address: '上海市普陀区金沙江路 1518 弄'
          }, {
            date: '2016-05-04',
            name: '王小虎',
            address: '上海市普陀区金沙江路 1517 弄'
          }, {
            date: '2016-05-01',
            name: '王小虎',
            address: '上海市普陀区金沙江路 1519 弄'
          }, {
            date: '2016-05-03',
            name: '王小虎',
            address: '上海市普陀区金沙江路 1516 弄'
          }],
          typeList:[],
          typeNow:-1,

          dataInfo:{},
          pageNo:1,
          pageSize:10,

          indexSelete1:'行业动态',
          indexSelete2:'认证赋能',
          indexSelete3:'产品技术性能指导',

          pictureList:[],
          needList:[
          ],//8个
          newList:[
          ],
          developList:[
          ],
          technicalList:[
          ],
          showList:[
          ],//6个
          consumerRightsProtectionList:[
          ],//6个
      }
    },
    mounted() {
      this.getData()
    },
    methods: {
      getContent(richText) {
        if (!richText) {
            return '';
        }
        let parser = new DOMParser();
        let doc = parser.parseFromString(richText, 'text/html');
        return doc.body.textContent;
      },
      tab1(name) {
        this.indexSelete1 = name;
        this.getTabData(name).then(res => {
          if (res.success) {
            this.newList = res.result.records
          }
        })
      },
      tab2(name) {//企业发展
        this.indexSelete2 = name;
        this.getTabData(name).then(res => {
          if (res.success) {
            this.developList = res.result.records
          }
        })
      },
      tab3(name) {//技术服务
        this.indexSelete3 = name;
        this.getTabData(name).then(res => {
          if (res.success) {
            this.technicalList = res.result.records
          }
        })
      },
      getTabData(name) {
        return new Promise((resolve, reject)=>{
          Server.getlzcjfwContent2({
            typename:name
          }).then(res => {
            resolve(res)
          }).catch(e => {
            reject(e)
          })
        })
      },
      more(title) {
        console.log(title);
        
        this.$router.push({
            path: '/chujuSub',
            query:{
              typename:title
            }
        })
      },
      toDetail(item,name,showName) {
        this.$router.push({
            path: '/cjContentDetail',
            query:{
              id:item.id,
              isMain:true,
              typename:name,
              showName:showName
            }
        })
      },
      getUrl() {
        return httpurl + '/sys/common/static/';
      },
      getData() {
          //needList//  需求征集  newList //新闻咨询  developList//企业发展  technicalList//技术服务  showList//企业展示  consumerRightsProtectionList//消费维权
          Server.getChujuMainInfo().then((res) => {
            console.log(res);
            if(res.success) {
              res.result.forEach(item => {
                switch(item.typeName) {
                  case '图片新闻':
                    this.pictureList = item.children;
                    break;
                  case '行业动态':
                    this.newList = item.children;
                    break;
                  case '企业发展':
                    this.developList = item.children;
                    break;
                  case '技术服务':
                    this.technicalList = item.children;
                    break;
                  case '企业展示':
                    this.showList = item.children;
                    break;
                  case '需求征集':
                    this.needList = item.children;
                    break;
                  case '消费维权':
                    this.consumerRightsProtectionList = item.children;
                    break;
                }
              })
            }
          })
      },
      jiliangCurrentPage(page,item,index) {
        console.log(page,item);
        this.getMore(page,item,index)
      },
      jiliangXia(page,item,index) {
        console.log(item);
        this.pageNo = page + 1;
      },
      jiliangShang(page,item,index) {
        this.pageNo = page - 1;
      },
      detail(item) {
        this.$router.push({
            path: '/cjContentDetail',
            query:{
              id:item.id,
              // typename:item.typename
            }
        })
      },
      getMore(pages,item,index) {
        var type = item.records[0].type
        Server.getlzcjfwContent2({
          type:type,
          pageNo:pages
        }).then((res) => {
            if (res.code == 200) {
              console.log(this.typeList);
              res.result.pageNo = pages
              this.typeList.splice(index, 1, res.result);
              console.log(this.typeList);
                // this.typeList = res.result
            }
            
            // this.contentList.sort((a, b) => {
            //     return a.releaseTime < b.releaseTime ? -1 : 1
            // })
            // console.log(this.contentList)
        });
      },
      getLegislation() {
        this.typeList = []
        Server.getlzcjfwContent1({
          titleType:this.dataInfo.id,
        }).then((res) => {
            if (res.code == 200) {
                this.typeList = res.result
                this.typeList.forEach(item => {
                  item.pageNo = 1
                })
            }
            
            // this.contentList.sort((a, b) => {
            //     return a.releaseTime < b.releaseTime ? -1 : 1
            // })
            // console.log(this.contentList)
        });
      },
  
      back(num) {
          this.$router.go(num)
      },
      fixImage (file) {
        var arr = file.split("/"); // 使用逗号分割字符串
        var lastElement = arr.slice(-1)[0]; // 取得最后一个元素
        return lastElement
      },
  
      async downloadExcel (fileName) {
          var fileUrl = this.getUrl()
          var fileLastName = fileName.title + this.fixImage(fileName.files).slice(this.fixImage(fileName.files).lastIndexOf('.'))

          const x = new window.XMLHttpRequest();
          console.log(fileUrl + fileName.files);
          
            x.open('GET', fileUrl + fileName.files, true);
            x.responseType = 'blob';
            x.onload = () => {
                const url = window.URL.createObjectURL(x.response);
                const a = document.createElement('a');
                a.href = url;
                a.download = fileLastName;
                a.click();
            };
            x.send();
      }
    }
  }
</script>
<style>
    .top-bottom {
        width: 100%;
        /* height: 350px; */
        img {
            width: 100%;
            height: 100%;
        }
    }
    .textSelected {
        color: #F68B25;
        background-color: white;
        padding: -5px;
    }
    .noTextSelected {
        color: #0053B9;
    }

      .two-line-ellipsis {

        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-all;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        line-height: 1.2em;
        max-height: 2.4em;
      }
    
      .one-line-ellipsis {
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-all;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        line-height: 1.2em;
        max-height: 2.4em;
      }
</style>